export const TIPOS_CLIENTE = ["Venezolano", "Extranjero", "Jurídico"]

export const UNIDADES = {
  unid: "Unidades",
  cm: "Centímetros",
  mt: "Metros",
  km: "Kilómetros",
  g: "Gramos",
  mg: "Miligramos",
  kg: "Kilogramos",
  ton: "Toneladas",
  ml: "Mililitros",
  lt: "Litros",
  caja: "Caja",
  paq: "Paquete",
}

export const DIAS = [7, 10, 15]

export const TIPOS_PAGO_SIMPLE = {
  punto: "Punto de Venta",
  dolar: "Efectivo ($)",
  Credito: "Credito",
}

export const TIPOS_PAGO_CRUD = {
  pagomovil: "Pago Móvil",
  transferencia: "Transferencia",
  zelle: "Zelle",
  binance: "Binance",
}

export const TIPOS_PAGO = {
  ...TIPOS_PAGO_SIMPLE,
  ...TIPOS_PAGO_CRUD,
}

export const BANCOS = [
  "BANCAMIGA",
  "BANCARIBE",
  "BANCO ACTIVO",
  "BANCO AGRICOLA",
  "BANCO CARONI",
  "BANCO DE VENEZUELA",
  "BANCO DEL CARIBE",
  "BANCO DEL SUR",
  "BANCO DEL TESORO",
  "BANCO DIGITAL DE LOS TRABAJDORES",
  "BANCO EXTERIOR",
  "BANCO MERCANTIL",
  "BANCO PLAZA",
  "BANCO PROVINCIAL",
  "BANCRECER",
  "BANESCO",
  "BANFANB",
  "BANGENTE",
  "BANPLUS",
  "BFC",
  "MI BANCO",
  "NACIONAL DE CREDITO",
  "SOFITASA",
  "VENEZOLANO DE CREDITO",
  "100 X 100 BANCO",
]

export const PERMISOS_RUTAS = {
  AbonosComponent: "vistas.abonos",
  ReporteApartados: "vistas.apartados",
  ChoferesComponent: "vistas.choferes",
  ClientesComponent: "vistas.clientes",
  ReporteCotizaciones: "vistas.cotizaciones",
  ReporteCuentas: "vistas.cuentas",
  DeliveriesComponent: "vistas.deliveries",
  HistorialComponent: "vistas.historial",
  ProductosComponent: "vistas.inventario",
  MarcasCategorias: "vistas.marcas_categorias",
  MetodosComponent: "vistas.metodos",
  PagosComponent: "vistas.pagos",
  ProveedoresComponent: "vistas.proveedores",
  RolesComponent: "vistas.roles",
  UsuariosComponent: "vistas.usuarios",
  ReporteVentas: "vistas.ventas",
  RealizarVentas: "vistas.vender",
  AgregarCliente: "clientes.registrar",
  EditarCliente: "clientes.editar",
  EditarChofer: "choferes.editar",
  AgregarProveedor: "proveedores.registrar",
  EditarProveedor: "proveedores.editar",
  AgregarRol: "roles.registrar",
  EditarRol: "roles.editar",
  AgregarUsuario: "usuarios.registrar",
  EditarUsuario: "usuarios.editar",
  AgregarMetodo: "metodos.registrar",
  EditarMetodo: "metodos.editar",
  RealizarAbono: "ventas.realizar_abono",
  AgregarProducto: "productos.registrar",
  EditarProducto: "productos.editar",
  EditarVenta: "ventas.editar",
  EditarCuentas: "cuentas.editar",
  EditarApartados: "apartados.editar",
  EditarAbonos: "abonos.editar",
}

export const PERMISOS = {
  "vistas.marcas_categorias": "Ver marcas y categorías",
  "marcas.registrar": "Registrar marca",
  "marcas.editar": "Editar marca",
  "marcas.eliminar": "Eliminar marca",
  "categorias.registrar": "Registrar categoría",
  "categorias.editar": "Editar categoría",
  "categorias.eliminar": "Eliminar categoría",
  "vistas.choferes": "Ver choferes",
  "choferes.editar": "Editar chofer",
  "choferes.pagar_chofer": "Registrar pago a chofer",
  "vistas.deliveries": "Ver deliveries",
  "vistas.clientes": "Ver clientes",
  "clientes.registrar": "Registrar cliente",
  "clientes.editar": "Editar cliente",
  "clientes.eliminar": "Eliminar cliente",
  "vistas.metodos": "Ver métodos de pago",
  "metodos.registrar": "Registrar método de pago",
  "metodos.editar": "Editar método de pago",
  "metodos.eliminar": "Eliminar método de pago",
  "vistas.inventario": "Ver productos",
  "productos.registrar": "Registrar producto",
  "productos.editar": "Editar producto",
  "productos.eliminar": "Eliminar producto",
  "productos.agregar_existencia": "Agregar existencia",
  "productos.remover_existencia": "Retirar existencia",
  "vistas.proveedores": "Ver proveedores",
  "proveedores.registrar": "Registrar proveedor",
  "proveedores.editar": "Editar proveedor",
  "vistas.pagos": "Ver pagos a proveedores",
  "proveedores.pagar_proveedor": "Registrar pago a proveedor",
  "vistas.roles": "Ver roles",
  "roles.registrar": "Registrar rol",
  "roles.editar": "Editar rol",
  "vistas.usuarios": "Ver usuarios",
  "usuarios.registrar": "Registrar usuario",
  "usuarios.editar": "Editar usuario",
  "usuarios.eliminar": "Eliminar usuario",
  "vistas.ventas": "Ver ventas",
  "ventas.registrar_venta": "Registrar venta",
  "vistas.cuentas": "Ver cuentas",
  "ventas.registrar_cuenta": "Registrar cuenta",
  "vistas.apartados": "Ver apartados",
  "ventas.registrar_apartado": "Registrar apartado",
  "vistas.cotizaciones": "Ver cotizaciones",
  "ventas.registrar_cotiza": "Registrar cotización",
  "ventas.eliminar_cotiza": "Eliminar cotizacion",
  "vistas.abonos": "Ver abonos",
  "ventas.realizar_abono": "Registrar abono",
  "vistas.historial": "Ver movimientos",
  "ventas.editar": "Editar venta",
  "ventas.eliminar": "Eliminar venta",
  "cuentas.editar": "Editar cuenta",
  "cuentas.eliminar": "Eliminar cuenta",
  "apartados.eliminar": "Eliminar apartado",
  "apartados.editar": "Editar apartado",
  "abonos.editar": "Editar abono",
}
